import { capitalize } from "lodash";
import { ReportType } from "../../graphql/generated";

const reportTypeLabel = (reportType: ReportType) => {
  return capitalize(reportType.replaceAll("_", " "));
};

export default reportTypeLabel;
